import { render } from "./IconMore.vue?vue&type=template&id=9eea9db0"
import script from "./IconMore.vue?vue&type=script&lang=js"
export * from "./IconMore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__